export default __webpack_public_path__ + "static/media/lineG2pt.62a876a5.png";